import { render, staticRenderFns } from "./PortalInput.vue?vue&type=template&id=7c05d3d6&scoped=true"
import script from "./PortalInput.vue?vue&type=script&lang=js"
export * from "./PortalInput.vue?vue&type=script&lang=js"
import style0 from "./PortalInput.vue?vue&type=style&index=0&id=7c05d3d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c05d3d6",
  null
  
)

export default component.exports